<template>
  <router-link :to="{path: '/blog/' + slug }">
    <div class="blog-card">
      <figure
        :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
        style="background-size: auto"
      >
        <div class="date">
          <span class="card-date-day">{{ day }}</span><span class="card-date-month">{{ month }}</span>
        </div>

        <span v-if="tags">
          <div class="tags">
            <span class="card-date-day">{{ tags }}</span>
          </div>
        </span>

        <figcaption>
          <h3 class="heading-tertiary--accent">
            <span>{{ title }}</span>
          </h3>
          <p>{{ content }}</p>
        </figcaption>
      </figure>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'BlogCard',
  props: [
    'title',
    'slug',
    'content',
    'datecreated',
    'backgroundImage',
    'tags'
  ],
  computed: {
    day () {
      
      let day = new Date(this.datecreated * 1000)
      day = day.getDate()
      return day
    },
    month () {
      let month = new Date(this.datecreated * 1000)
      month = month.getMonth()
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
      const selectedMonthName = months[month]
      return selectedMonthName
    }
  }
}
</script>
